import React from 'react'
import './ShopPage.scss';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import carImage from '../imgs/shop-category-car.svg'
import bikeImage from '../imgs/shop-category-bike.svg'
import vanImage from '../imgs/shop-category-ktp.svg'
import voucherImage from '../imgs/shop-category-voucher.svg'
import camperImage from '../imgs/shop-category-camper.svg'
import trailerImage from '../imgs/shop-category-trailer.svg'

import { Swipeable } from 'react-touch';

import { push } from 'connected-react-router'

import OrderCalendarPage from './OrderCalendarPage';
import VoucherPage from './VoucherPage';

import { loadShopData } from '../actions'
import { objectToArray } from '../helper'
import { Link } from 'react-router-dom'
import OfferSlider from '../components/OfferSlider'

import postNavButtonImage from '../scss/imgs/posts-nav-buttton.svg'

const renderShopPage = (props, content) => {
    loadShopData()

    return (
        <article className={"shop-page page"}>
            {props.location.pathname == "/shop/" && (
                <section className="section white-section on-screen">
                    <div className="section-content">
                        <div className="container">
                            <div className="grid">
                                <div className="col w2 p1 text-center">
                                    <h1 className="">Unser Online-Shop</h1>
                                    <div className="text ">
                                        <p className="p1">Sie können hier direkt einen Termin buchen oder jemanden eine Freude mit einem unvergesslichen Erlebnis machen.</p>
                                        <p className="p1">Weiterhin besteht auch die Möglichkeit einen Geschenkgutschein telefonisch unter 02843-991955 anzufordern!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
            {content}
        </article>
    );
}

class ShopCategories extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            index: 0
        }
    }

    right() {
        this.setState({ index: Math.min(this.state.index + 1, 4) })
    }

    left() {
        this.setState({ index: Math.max(this.state.index - 1, 0) })
    }

    render() {
        let translateX = 0;
        if (this.state.index > 0) {
            translateX = (window.innerWidth - 40) * -this.state.index;
        }

        return <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <h1 className="text-center shop-title">Trainingskategorie wählen</h1>
                    <Swipeable onSwipeLeft={() => this.right()} onSwipeRight={() => this.left()}>
                        <div ref="container" className="shop-category-list-container">
                            {this.state.index > 0 && (
                                <button className="shop-category-list-left" onClick={() => this.left()}>
                                    <img src={postNavButtonImage} />
                                </button>
                            )}
                            {this.state.index < 4 && (
                                <button className="shop-category-list-right" onClick={() => this.right()}>
                                    <img src={postNavButtonImage} />
                                </button>
                            )}
                            <div ref="list" className="shop-category-list" style={{ transform: "translateX(" + translateX + "px)" }}>

                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={bikeImage} alt="Motorrad-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        Motorrad
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/motorrad" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={carImage} alt="PKW-Training" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        PKW
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/pkw" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={vanImage} alt="Transporter" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        Transporter
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/ktp" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={trailerImage} alt="Anhänger" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        Anhänger
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/anhänger" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                                { false && <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={camperImage} alt="Wohnmpbil" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        Wohnmobil
                                    </div>
                                    <div className="shop-category-button">
                                        <Link to="/shop/wohnmobil" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div> }
                                <div className="shop-category">
                                    <div className="shop-category-image-container">
                                        <img className="img" src={voucherImage} alt="Wertgutschein" />
                                    </div>
                                    <div className="shop-category-type">
                                        Fahrzeugkategorie
                                    </div>
                                    <div className="shop-category-title">
                                        Gutscheine
                                    </div>
                                    <div className="shop-category-button">
                                        <Link key='amount' to="/shop/gutscheine/" className="btn">Jetzt buchen</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Swipeable>
                </div>
            </div>
        </section>
    }
}

const renderCategories = (props) => {
    return (
        <ShopCategories />
    )
}

const renderTypes = (props) => {
    const trainingTypes = objectToArray(props.trainingTypes)
        .filter(t => t.vehicleTypeId == props.match.params.vehicleTypeId)

    return (
        <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <p className="text-center">
                        <button className="white-btn" onClick={props.gotoShop}>zurück</button>
                    </p>
                    <h1 className="text-center shop-title">Training auswählen</h1>
                    <OfferSlider vehicleTypeId={props.match.params.vehicleTypeId} />
                </div>
            </div>
        </section>
    )
}

const renderCalendar = (props) => {
    return (
        <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <h1 className="text-center shop-title">Termin auswählen</h1>
                    <OrderCalendarPage {...props} />
                </div>
            </div>
        </section>
    )
}

const renderVoucher = (props) => {
    return (
        <section className="section gray-section on-screen">
            <div className="section-content">
                <div className="container">
                    <h1 className="text-center shop-title">Gutschein personalisieren</h1>
                    <VoucherPage
                        {...props}
                        handleVoucherText={(text) => props.voucherTextChanged(text)}
                        handleVoucherAmount={(amount) => props.voucherAmountChanged(amount)}
                    />
                </div>
            </div>
        </section>
    )
}

const renderContent = (props) => {
    if (!props.match.params.vehicleTypeId)
        return renderCategories(props)

    if (!props.match.params.trainingTypeId)
        return renderTypes(props)

    switch (props.step) {
        case 'calendar':
            return renderCalendar(props)
        case 'voucher':
            return renderVoucher(props)
    }

    return renderCalendar(props);
}

class ShopPage extends React.Component {
    componentDidMount() {
        if (this.props.match.path === "/shop/:vehicleTypeId")
            this.props.shopStarted()
    }

    render() {
        const props = this.props
        const content = renderContent(props);
        return renderShopPage(props, content)
    }
}

const mapStateToProps = state => {
    return {
        ...state.shop,
        trainingId: state.order.trainingId,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        gotoShop: () => dispatch(push('/shop/')),
        shopStarted: () => dispatch({ type: 'SHOP_STARTED' }),
        loadShopData: () => dispatch(loadShopData()),
        resetCategory: () => dispatch({ type: 'SHOP_CHOOSE_CATEGORY', category: null }),
        chooseCategory: (category) => dispatch({ type: 'SHOP_CHOOSE_CATEGORY', category: category }),
        resetType: () => dispatch({ type: 'SHOP_CHOOSE_TYPE', offerType: null }),
        chooseType: (offerType) => dispatch({ type: 'SHOP_CHOOSE_TYPE', offerType: offerType }),
        resetDateAndSlots: () => dispatch({ type: 'SHOP_CONFIRM_DATE_AND_SLOTS', confirmed: false }),
        confirmDateAndSlots: () => dispatch({ type: 'SHOP_CONFIRM_DATE_AND_SLOTS', confirmed: true }),
        voucherAmountChanged: (amount) => dispatch({ type: 'SHOP_VOUCHER_AMOUNT_CHANGED', amount: amount }),
        voucherTextChanged: (text) => dispatch({ type: 'SHOP_VOUCHER_TEXT_CHANGED', text: text }),
        resetVoucher: () => dispatch({ type: 'SHOP_VOUCHER_CONFIRMED', confirmed: false }),
        book: (type, voucher) => dispatch({ type: 'SHOP_BOOK', offerType: type, voucher }),
        confirmVoucher: () => dispatch({ type: 'SHOP_VOUCHER_CONFIRMED', confirmed: true }),
        invoiceInfoValueChanged: (name, value) => dispatch({ type: 'SHOP_INVOICE_INFO_UPDATED', name: name, value: value }),
        resetInvoiceInfo: () => dispatch({ type: 'SHOP_CONFIRM_INVOICE_INFO', confirmed: false }),
        confirmInvoiceInfo: () => dispatch({ type: 'SHOP_CONFIRM_INVOICE_INFO', confirmed: true }),
        onSelectedSlotsChanged: (slots) => dispatch({ type: 'SHOP_SELECT_SLOTS', slots: slots }),
        next: () => dispatch({ type: 'SHOP_NEXT_STEP' }),
        prev: () => dispatch({ type: 'SHOP_PREV_STEP' }),
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ShopPage))


// WEBPACK FOOTER //
// ./src/pages/ShopPage.jsx